<!-- 客户自助提交订单页 -->
<template>
  <div class="order-submit-page">
    <Navbar />

    <!-- 页头 -->
    <section class="submit-hero">
      <div class="submit-hero-overlay"></div>
      <div class="container">
        <div class="submit-hero-content">
          <span class="section-tag">SUBMIT ORDER</span>
          <h1 class="submit-hero-title">凹陷修复订单</h1>
          <p class="submit-hero-desc">上传修复前照片，专业团队为您评估修复方案</p>
          <div class="hero-divider">
            <span class="line"></span><span class="diamond"></span><span class="line"></span>
          </div>
        </div>
      </div>
    </section>

    <!-- 表单区域 -->
    <section class="form-section">
      <div class="container">
        <div class="form-wrapper">
          <el-form ref="formRef" :model="form" :rules="rules" :label-width="isMobile ? '100%' : '90px'" label-position="top" class="dent-form">

            <!-- 订单状态 -->
            <div class="form-section-title">
              <span class="section-num">00</span>
              <span class="section-label">订单状态</span>
            </div>
            <el-form-item label="订单状态">
              <el-select v-model="form.status" placeholder="请选择订单状态" style="width:100%">
                <el-option label="待接单" value="1" />
                <el-option label="维修中" value="2" />
                <el-option label="已完成" value="3" />
                <el-option label="已取消" value="4" />
              </el-select>
            </el-form-item>

            <!-- 客户信息 -->
            <div class="form-section-title">
              <span class="section-num">01</span>
              <span class="section-label">客户信息</span>
            </div>
            <div class="form-row">
              <div class="form-col">
                <el-form-item label="客户姓名" prop="customerName">
                  <el-input v-model="form.customerName" placeholder="请输入您的姓名" clearable />
                </el-form-item>
              </div>
              <div class="form-col">
                <el-form-item label="联系电话" prop="phone">
                  <el-input v-model="form.phone" placeholder="请输入手机号码" clearable
                            type="tel" maxlength="11"
                            @input="form.phone = form.phone.replace(/\D/g, '').slice(0, 11)" />
                </el-form-item>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col form-col-full">
                <el-form-item label="客户来源">
                  <el-select v-model="form.customerSource" placeholder="请选择客户来源" clearable style="width:100%">
                    <el-option label="抖音" value="抖音" />
                    <el-option label="美团" value="美团" />
                    <el-option label="小红书" value="小红书" />
                    <el-option label="地图" value="地图" />
                    <el-option label="百度" value="百度" />
                    <el-option label="朋友推荐" value="朋友推荐" />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <!-- 地址信息 -->
            <div class="form-section-title">
              <span class="section-num">02</span>
              <span class="section-label">地址信息</span>
            </div>
            <div class="form-row">
              <div class="form-col">
                <el-form-item label="城市">
                  <el-input value="北京市" disabled />
                </el-form-item>
              </div>
              <div class="form-col">
                <el-form-item label="区县">
                  <el-select v-model="form.district" placeholder="请选择区县" style="width:100%">
                    <el-option v-for="d in beijingDistricts" :key="d" :label="d" :value="d" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col form-col-full">
                <el-form-item label="详细地址">
                  <el-input v-model="form.address" type="textarea" :rows="2"
                            placeholder="请输入详细地址" clearable />
                </el-form-item>
              </div>
            </div>

            <!-- 车辆信息 -->
            <div class="form-section-title">
              <span class="section-num">03</span>
              <span class="section-label">车辆信息</span>
            </div>
            <div class="form-row">
              <div class="form-col form-col-3">
                <el-form-item label="车牌号码">
                  <el-input v-model="form.plateNumber" placeholder="如：京A88888" clearable />
                </el-form-item>
              </div>
              <div class="form-col form-col-3">
                <el-form-item label="车型">
                  <el-input v-model="form.carModel" placeholder="如：奥迪A4L" clearable />
                </el-form-item>
              </div>
              <div class="form-col form-col-3">
                <el-form-item label="车辆颜色">
                  <el-input v-model="form.carColor" placeholder="如：黑色" clearable />
                </el-form-item>
              </div>
            </div>

            <!-- 凹陷信息 -->
            <div class="form-section-title">
              <span class="section-num">04</span>
              <span class="section-label">凹陷信息</span>
            </div>
            <div class="form-row">
              <div class="form-col">
                <el-form-item label="凹陷位置">
                  <el-input v-model="form.damageLocation" placeholder="如：左前门、引擎盖左侧" clearable />
                </el-form-item>
              </div>
              <div class="form-col">
                <el-form-item label="金额(元)">
                  <el-input-number v-model="form.estimatedAmount" :min="0" :precision="0"
                                   style="width:100%" />
                </el-form-item>
              </div>
              <div class="form-col">
                <el-form-item label="服务时长(小时)">
                  <el-input-number v-model="form.serviceHours" :min="0" :precision="1" :step="0.5"
                                   style="width:100%" />
                </el-form-item>
              </div>
            </div>
            <el-form-item label="损伤描述">
              <el-input v-model="form.damageDesc" type="textarea" :rows="3"
                        placeholder="请详细描述损伤情况，方便我们评估修复方案" clearable />
            </el-form-item>

            <!-- 照片上传 -->
            <div class="form-section-title">
              <span class="section-num">05</span>
              <span class="section-label">修复照片</span>
            </div>
            <div class="form-row">
              <div class="form-col">
                <el-form-item label="修复前照片">
                  <upload-multiple v-model:file-list="beforeList" :limit="10" />
                  <div class="upload-hint">上传凹陷现状照片，最多10张，每张不超过5MB</div>
                </el-form-item>
              </div>
              <div class="form-col">
                <el-form-item label="修复后照片">
                  <upload-multiple v-model:file-list="afterList" :limit="10" />
                  <div class="upload-hint">如有修复后照片可一并上传（可选）</div>
                </el-form-item>
              </div>
            </div>

            <!-- 备注 -->
            <div class="form-section-title">
              <span class="section-num">06</span>
              <span class="section-label">备注信息</span>
            </div>
            <el-form-item label="客户备注">
              <el-input v-model="form.remark" type="textarea" :rows="2"
                        placeholder="如有其他需求请在此说明（可选）" clearable />
            </el-form-item>

            <!-- 提交 -->
            <el-form-item class="submit-item">
              <el-button type="primary" :loading="submitting" size="large" class="submit-btn" @click="handleSubmit">
                提交订单
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import Navbar from '@/components/Navbar.vue'
import UploadMultiple from '@/components/UploadMultiple.vue'

const router = useRouter()
const store = useStore()
const formRef = ref()
const submitting = ref(false)
const beforeList = ref([])
const afterList = ref([])
const isMobile = ref(window.innerWidth <= 768)

// 监听窗口大小变化
window.addEventListener('resize', () => {
  isMobile.value = window.innerWidth <= 768
})

onMounted(() => {
  if (!store.getters.isLoggedIn) {
    router.push({ path: '/auth', query: { redirect: '/order-submit' } })
  }
})

const beijingDistricts = ['东城区', '西城区', '朝阳区', '丰台区', '石景山区', '海淀区', '门头沟区', '房山区', '通州区', '顺义区', '昌平区', '大兴区', '怀柔区', '平谷区', '密云区', '延庆区']

const form = reactive({
  customerName: '', phone: '', province: '北京市', city: '北京市', district: '', address: '',
  plateNumber: '', carModel: '', carColor: '',
  damageLocation: '', damageDesc: '', estimatedAmount: 0, serviceHours: 0, remark: '',
  customerSource: '', status: '3'
})

const rules = reactive({
  customerName: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
  ]
})

const handleSubmit = async () => {
  await formRef.value.validate(async (valid) => {
    if (!valid) return
    submitting.value = true
    try {
      const fd = new FormData()
      fd.append('customerName', form.customerName)
      fd.append('phone', form.phone)
      fd.append('province', '北京市')
      fd.append('city', '北京市')
      fd.append('district', form.district)
      fd.append('address', form.address)
      fd.append('plateNumber', form.plateNumber)
      fd.append('carModel', form.carModel)
      fd.append('carColor', form.carColor)
      fd.append('damageLocation', form.damageLocation)
      fd.append('damageDesc', form.damageDesc)
      fd.append('estimatedAmount', form.estimatedAmount)
      fd.append('serviceHours', form.serviceHours)
      fd.append('remark', form.remark)
      fd.append('customerSource', form.customerSource)
      fd.append('status', form.status)
      beforeList.value.forEach(f => fd.append('beforeImages', f.raw))
      afterList.value.forEach(f   => fd.append('afterImages', f.raw))

      const res = await fetch('/webapi/dent/order/submit', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${store.state.token}` },
        body: fd
      })
      const data = await res.json()
      if (data.ActionType === 'OK') {
        ElMessage.success('订单提交成功！我们会尽快与您联系。')
        router.push('/my-orders')
      } else {
        ElMessage.error(data.errorInfo || '提交失败，请重试')
      }
    } catch (e) {
      ElMessage.error('网络错误，请稍后重试')
    } finally {
      submitting.value = false
    }
  })
}
</script>

<style lang="scss" scoped>
$gold: #d4af37;
$dark: #1a1a1a;
$gray: #6b7280;

/* ========== 基础布局 ========== */
.order-submit-page { min-height: 100vh; background: #f5f7fa; }

.submit-hero {
  position: relative;
  min-height: 260px;
  margin-top: 72px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  display: flex;
  align-items: center;
  overflow: hidden;
}

.container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

.submit-hero-content {
  position: relative; z-index: 1;
  text-align: center;
  padding: 60px 0;
}

.section-tag {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 3px;
  color: $gold;
  margin-bottom: 16px;
}

.submit-hero-title {
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
  letter-spacing: 2px;
}

.submit-hero-desc {
  font-size: 16px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 24px;
}

.hero-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  .line { width: 60px; height: 1px; background: rgba(212,175,55,0.5); }
  .diamond { width: 8px; height: 8px; background: $gold; transform: rotate(45deg); }
}

.form-section { padding: 48px 0 80px; }

.form-wrapper {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
}

.form-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 28px 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;

  .section-num {
    font-size: 13px;
  font-weight: 700;
  color: $gold;
  background: rgba(212,175,55,0.1);
  padding: 2px 10px;
  border-radius: 20px;
  }
  .section-label { font-size: 16px; font-weight: 600; color: $dark; }
  &:first-child { margin-top: 0; }
}

/* ========== 表单网格布局 ========== */
.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 0;
}

.form-col {
  flex: 1;
}

.form-col-3 {
  flex: 0 0 calc(33.333% - 11px);
  max-width: calc(33.333% - 11px);
}

.form-col-full {
  flex: 0 0 100%;
  max-width: 100%;
}

.dent-form {
  :deep(.el-form-item) {
    margin-bottom: 20px;
    .el-form-item__label {
      padding-bottom: 6px;
      line-height: 1.4;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  :deep(.el-form-item__label) {
    font-weight: 500;
    color: $dark;
    font-size: 14px;
    padding-bottom: 6px;
    line-height: 1.4;
  }
  :deep(.el-form-item__content) { margin-left: 0 !important; }
  :deep(.el-input__wrapper) {
    border-radius: 8px;
    font-size: 14px;
  }
  :deep(.el-textarea__inner) {
    border-radius: 8px;
  }
}

.upload-hint { font-size: 12px; color: #bbb; margin-top: 6px; }

.submit-item {
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
}

.submit-btn {
  height: 48px;
  padding: 0 48px;
  font-size: 15px;
  font-weight: 600;
  background: linear-gradient(135deg, $gold 0%, #b8941f 100%);
  border: none;
  border-radius: 8px;
  &:hover { background: linear-gradient(135deg, #e6c040 0%, $gold 100%); }
}

.submit-hint { margin-left: 16px; font-size: 13px; color: $gray; }

/* ========== 手机端适配（768px以下） ========== */
@media screen and (max-width: 768px) {
  /* 导航栏适配 */
  .site-header {
    height: 56px !important;
  }
  .header-inner {
    height: 56px !important;
  }

  .submit-hero {
    min-height: 140px;
    margin-top: 56px;
  }
  .submit-hero-content { padding: 20px 16px; }
  .section-tag { font-size: 10px; letter-spacing: 2px; margin-bottom: 8px; }
  .submit-hero-title { font-size: 20px; margin-bottom: 6px; letter-spacing: 1px; }
  .submit-hero-desc { font-size: 12px; margin-bottom: 12px; }
  .hero-divider { gap: 8px;
    .line { width: 24px; height: 1px; }
    .diamond { width: 4px; height: 4px; }
  }

  .form-section { padding: 16px 0 32px; }
  .container { padding: 0 12px; }
  .form-wrapper {
    border-radius: 12px;
    padding: 16px 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }

  .form-section-title {
    margin: 12px 0 10px;
    padding-bottom: 8px;
    gap: 6px;
    .section-num { font-size: 10px; padding: 1px 6px; }
    .section-label { font-size: 13px; }
  }

  /* 表单行改为单列 */
  .form-row {
    display: block !important;
    gap: 0 !important;
    margin-bottom: 0 !important;
  }
  .form-col,
  .form-col-3,
  .form-col-full {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    margin-bottom: 0 !important;
  }

  /* Element Plus 表单适配 - 强制顶部标签布局 */
  .dent-form :deep(.el-form-item) {
    margin-bottom: 14px !important;
    display: block !important;
  }
  .dent-form :deep(.el-form-item__label) {
    float: none !important;
    width: 100% !important;
    max-width: 100% !important;
    text-align: left !important;
    padding-bottom: 4px !important;
    font-size: 13px !important;
    line-height: 1.4 !important;
    height: auto !important;
  }
  .dent-form :deep(.el-form-item__content) {
    margin-left: 0 !important;
    width: 100% !important;
    display: block !important;
  }
  .dent-form :deep(.el-input__wrapper) {
    font-size: 14px;
    min-height: 36px;
    padding: 0 12px;
  }
  .dent-form :deep(.el-textarea__inner) {
    font-size: 14px;
    min-height: 80px;
  }
  .dent-form :deep(.el-input-number),
  .dent-form :deep(.el-select) {
    width: 100% !important;
  }

  /* 上传组件适配 */
  :deep(.el-upload--picture-card) {
    width: 72px !important;
    height: 72px !important;
    line-height: 72px !important;
  }
  :deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 72px !important;
    height: 72px !important;
  }
  :deep(.el-upload-list) {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  .upload-hint { font-size: 11px; margin-top: 4px; }
  .submit-item { margin-top: 24px; }
  .submit-btn {
    width: 100% !important;
    height: 48px !important;
    font-size: 16px !important;
    border-radius: 8px !important;
  }
}

/* ========== 小屏手机（375px以下） ========== */
@media screen and (max-width: 375px) {
  .submit-hero { min-height: 120px; }
  .submit-hero-content { padding: 16px 12px; }
  .submit-hero-title { font-size: 18px; }
  .form-wrapper { padding: 12px 10px; }
  .form-section-title { margin: 10px 0 8px; }
}
</style>
